import { Expose, Type } from "class-transformer";
import { CreateFileDto } from "@/core/features/file/create-file.dto";

export class CreateTemplateDto {
  @Expose()
  name: string;

  @Expose()
  description?: string;

  @Expose()
  @Type(() => CreateFileDto)
  file: CreateFileDto;
}
